import { XIcon } from "lucide-react";
import React, { SetStateAction, useState } from "react";

interface props {
  handleSubmit: (reason: string) => void;
  onClose: React.Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
  modalType?: string;
}
const CustomRejectionModal = ({
  handleSubmit,
  onClose,
  isLoading,
  modalType,
}: props) => {
  const [cancellationReason, setCancellationReason] = useState("");

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <div className="bg-white shadow-2xl  w-full max-w-[300px] mobile:max-w-[380px] md:max-w-lg p-6">
        <div className="w-full flex justify-between items-center  pb-3">
          <p className="font-openSans font-semibold text-web-body-lg leading-5 text-brand-bgBlack">
            {modalType === "reattempt"
              ? "Reattempt KYC Request"
              : modalType === "eventRejection"
              ? "Reject Event Request"
              : "Reject Bidder Request"}
          </p>
          <button
            onClick={() => {
              //   setShowRejectionModal(false);
              onClose(false);
            }}
            className="text-gray-500 bg-brand-bgLightGrey rounded-full p-1.5 hover:text-gray-700"
          >
            <XIcon className="h-6 w-6" />
          </button>
        </div>

        <div>
          {modalType !== "eventRejection" && (
            <p className="font-openSans text-xs text-brand-textGrey">
              Please select Re-attempt KYC steps only if there are issues with
              form fields. For document mismatches (like PAN or Aadhaar), it's
              recommended to reject the KYC instead. <br />
              <br />
              Please Ensure you provide a clear rejection reason so the bidder
              can correct the information before reapplying. <br />
            </p>
          )}
        </div>

        <div className={` relative w-full mt-5`}>
          <textarea
            id="name"
            value={cancellationReason}
            onChange={(e: any) => {
              setCancellationReason(e.target.value);
            }}
            className={`bg-white   py-4 peer pl-4 autofill:bg-white focus:border-brand-orange focus:outline-none focus:ring-0 pb-[6px] min-h-[120px]  outline-none  border border-[#EEEEEE]  w-full   font-openSans font-normal  leading-4 text-brand-textLightGrey `}
          />
          <label
            htmlFor="name"
            className={`absolute font-openSans font-normal text-web-body-sm leading-3 mid:text-web-body-lg mid:leading-5 ${
              !cancellationReason
                ? "text-brand-borderGrey"
                : "text-transparent hidden"
            } left-4 top-4 pointer-events-none transition-all duration-300 peer-placeholder-shown:top-1.5 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-[10px] peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:leading-[13px] peer-focus:text-brand-orange peer-valid:top-1.5 peer-valid:text-[10px] peer-valid:leading-[13px] peer-valid:text-brand-borderGrey`}
          >
            {modalType === "reattempt"
              ? "Reason For re-initiating the Bidder KYC Request"
              : modalType === "eventRejection"
              ? "Reason For Rejecting the Event Request"
              : "Reason For Rejecting the Bidder Request"}
          </label>
        </div>

        <div className="w-full flex justify-center mt-6">
          <button
            disabled={isLoading || cancellationReason === ""}
            className={`bg-brand-borderGrey text-white px-6 py-2 lg:w-[225px] ${
              cancellationReason === "" ? "cursor-not-allowed" : ""
            } rounded-lg hover:bg-brand-textGrey `}
            onClick={() => {
              //   handleRejectEvent(cancellationReason);
              handleSubmit(cancellationReason);
            }}
          >
            {modalType === "reattempt" ? "Submit" : "Reject"}
          </button>
        </div>
      </div>
    </div>
  );
};
export default CustomRejectionModal;
